import React from "react";
import { useTranslation } from "react-i18next";

const LmcRewardIncremental = ({ amount = 0 }: { amount?: number }) => {
  const { t } = useTranslation("clientView");

  return (
    <div className="w-full py-20 px-4 flex flex-col justify-start items-center gap-4">
      <h4 className="w-[158px] text-center text-gray-50 text-xl font-semibold font-figtree leading-7">
        {t("lmcUser.key44")}
      </h4>
      <h2 className="text-center text-green-300 text-6xl font-extrabold font-figtree leading-[60px]">
        {amount}
      </h2>
    </div>
  );
};

export default LmcRewardIncremental;
